var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"top":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},_vm._l((_vm.text),function(line,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(line)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }